import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { Box, CircularProgress } from '@mui/material';

const ProtectedRoute = ({ children, requiredPermission, requiredModule }) => {
  const { isAuthenticated, loading, user, isModuleEnabled } = useAuth();

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/auth/login" replace />;
  }

  // SUPER_ADMIN y Owner tienen acceso completo a todo
  if (user?.role === 'SUPER_ADMIN') {
    return children;
  }

  const isOwner = user?.roles?.some(r => r.name === 'Owner' || r.roleLevel === 1) || false;
  if (isOwner) {
    return children;
  }

  if (requiredModule && !isModuleEnabled(requiredModule)) {
    return <Navigate to="/403" replace />;
  }

  if (requiredPermission && !user?.allPermissions?.includes(requiredPermission)) {
    return <Navigate to="/403" replace />;
  }

  return children;
};

export default ProtectedRoute;
